import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/design/design/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { Box } from '@primer/react';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Caption = makeShortcode("Caption");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Box display="flex" mb={4} flexDirection="column" mdxType="Box">
  <Box display="flex" bg="gray.1" justifyContent="center" mdxType="Box">
    <img width="656" alt="Screenshot of the Primer profile within the Figma community" src="https://user-images.githubusercontent.com/10384315/93832644-3028e080-fc2b-11ea-88d1-a7515c04fe39.png" />
  </Box>
  <Caption mdxType="Caption">Primer is a part of the Figma community and can be found using its Figma handle of @primer</Caption>
    </Box>
    <p>{`Design teams at GitHub use Figma as the single source of truth, collaboration, and exploration. Access to the GitHub Figma organization is currently only available to members of the GitHub team. Public access to any shared libraries and files is available from the `}<a parentName="p" {...{
        "href": "https://www.figma.com/@primer"
      }}>{`Primer Figma Community page`}</a>{`.`}</p>
    <h2>{`Team libraries`}</h2>
    <p>{`GitHub uses Figma to distribute Primer through team libraries. Each library covers a different part of the system, allowing a designer to only use what's needed. Any team within GitHub's Figma organization can create and distribute their own team/project specific libraries, but all of the core asset libraries for Primer can be found in the Primer team's "`}<a parentName="p" {...{
        "href": "https://www.figma.com/files/797266083973274396/project/8172024/Core-libraries"
      }}>{`Core libraries`}</a>{`" project. They include the following:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.figma.com/file/B5XPE8IwGPIZDAvN7jqWqx/Primer-Primitives"
        }}>{`Primer Primitives`}</a>{`: All of the color, type, and spacing styles used within Primer.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.figma.com/file/GCvY3Qv8czRgZgvl1dG6lp/Primer-Web"
        }}>{`Primer Web`}</a>{`: UI components used to design for GitHub's web interfaces.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.figma.com/file/csCViryWkkXwBsK1aLrO0X/Primer-Mobile"
        }}>{`Primer Mobile`}</a>{`: UI components used to design for GitHub's native mobile platforms.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.figma.com/file/1ljgTFkT5NKNRfq5hw07JQ/Octicons"
        }}>{`Octicons`}</a>{`: GitHub's custom icon library.`}</li>
    </ul>
    <h2>{`Interface templates`}</h2>
    <Box display="flex" mb={4} flexDirection="column" mdxType="Box">
  <Box display="flex" bg="gray.1" justifyContent="center" mdxType="Box">
    <img width="656" alt="screenshot of repo home page and email template" src="https://user-images.githubusercontent.com/10384315/93832849-d1b03200-fc2b-11ea-98ff-685f22236f6f.png" />
  </Box>
  <Caption mdxType="Caption">Example templates from Primer Interfaces and Primer Email</Caption>
    </Box>
    <p>{`In addition to asset libraries for components and styles, you can also use template libraries to jump-start the design process.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.figma.com/file/Y2xJLFBrU7yyiDLlEkQXcF/Primer-Interfaces"
        }}>{`Primer Interfaces`}</a>{`: Templates for common views and UI patterns found within GitHub's web product.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.figma.com/file/MZM32u6Q80DOvOGlDCNIyc/Primer-Email"
        }}>{`Primer Email`}</a>{`: Templates used to design product emails for GitHub.`}</li>
    </ul>
    <h2>{`Collaboration`}</h2>
    <Box display="flex" mb={4} flexDirection="column" mdxType="Box">
  <Box display="flex" bg="gray.1" justifyContent="center" mdxType="Box">
    <img width="656" alt="Screenshot demonstrating collaboration in Figma using Figma comments" src="https://user-images.githubusercontent.com/10384315/93832938-0f14bf80-fc2c-11ea-9e8b-e72bee3b4fdd.png" />
  </Box>
  <Caption mdxType="Caption">Example communicating in Figma using comments</Caption>
    </Box>
    <p>{`All GitHub members have read-only access to all GitHub design files and edit access to files within their team. You can leave `}<a parentName="p" {...{
        "href": "https://help.figma.com/article/44-comments"
      }}>{`Figma comments`}</a>{` to provide feedback and use `}<a parentName="p" {...{
        "href": "https://help.github.com/en/articles/about-issues"
      }}>{`issues`}</a>{` to document design exploration, track decisions and progress. The design team values `}<a parentName="p" {...{
        "href": "https://github.com/github/product-design/blob/master/principles-and-practices.md#incremental-correctness"
      }}>{`incremental correctness`}</a>{`, so share early and share often.`}</p>
    <h2>{`Support`}</h2>
    <p>{`GitHub's Figma organization is currently maintained by GitHub's Design Infrastructure team. For any questions or comments please reach out to us either in our Slack `}<a parentName="p" {...{
        "href": "https://github.slack.com/archives/CSGAVNZ19"
      }}>{`#primer`}</a>{` channel or by submitting an issue in the `}<a parentName="p" {...{
        "href": "https://github.com/github/design-infrastructure/issues/new/choose"
      }}>{`github/design-infrastructure repo`}</a>{`. The Design Infrastructure team also offers weekly Figma office hours on Tuesdays, which are hosted by `}<a parentName="p" {...{
        "href": "https://github.com/ashygee"
      }}>{`@ashygee`}</a>{`. Please reach out to them for the calendar invite.`}</p>
    <p>{`For additional support specific to Figma, please reference the `}<a parentName="p" {...{
        "href": "https://help.figma.com/hc/en-us"
      }}>{`Figma Help Center`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      